function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.716 6.504L12.287 0.504C12.11 0.192 11.779 0 11.42 0H4.58C4.221 0 3.89 0.192 3.712 0.504L0.283001 6.504C0.107001 6.811 0.107001 7.189 0.283001 7.496L3.712 13.496C3.89 13.808 4.221 14 4.58 14H11.419C11.778 14 12.109 13.808 12.287 13.496L15.716 7.496C15.892 7.189 15.892 6.811 15.716 6.504ZM8 10C6.343 10 5 8.657 5 7C5 5.343 6.343 4 8 4C9.657 4 11 5.343 11 7C11 8.657 9.657 10 8 10Z",
  fill: "#002A95"
});

var SvgServices = function SvgServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Services.d0fc6188.svg";
export { ForwardRef as ReactComponent };